
import React, {
    useState,
    useEffect
}
from "react";

import { useHistory }
from "react-router-dom";

import { functions }
from "../../../constants/common-functions";

import {
    FontAwesomeIcon
}
from "@fortawesome/react-fontawesome";

import HeaderCard
from "../components/HeaderCard";

import HomeBoxProperties
from "../components/HomeBoxProperties";

import HomeBoxUtilisation
from "../components/HomeBoxUtilisation";

import HomeBoxSpace
from "../components/HomeBoxSpace";

import HomeBoxDocuments
from "../components/HomeBoxDocuments";

import HomeBoxLeases
from "../components/HomeBoxLeases";

import HomeBoxProjects
from "../components/HomeBoxProjects";

import HomeBoxHelpDesk
from "../components/HomeBoxHelpDesk";

import HomeBoxTasks
from "../components/HomeBoxTasks";

import HomeBoxMyTasks
from "../components/HomeBoxMyTasks";

import HomeDocumentsPanel
from "../components/HomeDocumentsPanel";

import AiInsightsPanel
from "../components/AiInsightsPanel";

import {
    OMNISCAN_BLUE
}
from "../../../constants/colors";

import MobileHeader
from "./components/MobileHeader";

import MobileMenu
from "./components/MobileMenu";

import MobileSearchPanel
from "./components/MobileSearchPanel";


import "./MobileHome.css";


//========================================================
// Mobile Home
//========================================================

export default function MobileHome({
    onAbout
})
{
    //--------------------------------------------------------
    // State
    //--------------------------------------------------------

    const history =
        useHistory();

    const [homeConfig, setHomeConfig] =
        useState();

    const [directories, setDirectories] =
        useState([]);

    const isLocalHost =
        functions.getIsDemoSystem();

    const [showMenu, setShowMenu] =
        useState(false);


    //--------------------------------------------------------
    // Initialise
    //--------------------------------------------------------

    useEffect(
        function()
        {
            functions.getObjectFromAjax(
                "/resolutionsoftwareplatform/home-setup",
                setHomeConfig,
                null
            );

            functions.getObjectFromAjax(
                "/resolutionsoftwareplatform/folderforager/directories",
                setDirectories,
                null
            );
        },
        []
    );


    //--------------------------------------------------------
    // Render
    //--------------------------------------------------------

    return (

        <div
            className="mobile-home"

            style={{
                width: "100%",
                maxWidth: "100vw",
                overflowX: "hidden",
                overflowY: "visible",
                boxSizing: "border-box"
            }}
        >

            {/* MOBILE HEADER */}

            <MobileHeader
                openMenu={
                    () => setShowMenu(true)
                }
                openSearch={
                    () => console.log("SEARCH")
                }
            />


            {/* ABOUT OMNISCAN */}

            <button
                type="button"

                className="mobile-home-about"

                onClick={onAbout}
            >

                <FontAwesomeIcon
                    icon="info-circle"
                />

                <span>
                    ABOUT OMNISCAN
                </span>

            </button>


            {/* SEARCH PANEL */}

            <MobileSearchPanel />


            {/* MAIN CONTENT */}

            <div
                className="mobile-home-content"

                style={{
                    width: "100%",
                    maxWidth: "100%",
                    overflowX: "hidden",
                    boxSizing: "border-box"
                }}
            >

                {/* ------------------------------------------
                    Data
                ------------------------------------------ */}

                <div className="mobile-home-section">

                    <HeaderCard
                        id="1"
                        title="Data"
                        color={OMNISCAN_BLUE}
                        icon="chart-bar"
                    />

                    <HomeBoxProperties
                        homeConfig={homeConfig}
                        isMobile={true}
                    />

                    <HomeBoxSpace
                        homeConfig={homeConfig}
                        isMobile={true}
                    />

                    <HomeBoxUtilisation
                        homeConfig={homeConfig}
                        isMobile={true}
                    />

                </div>


                {/* ------------------------------------------
                    Documents
                ------------------------------------------ */}

                <div className="mobile-home-section">

                    <HeaderCard
                        id="2"
                        title="Documents"
                        color={OMNISCAN_BLUE}
                        icon="file"
                    />

                    {
                        !isLocalHost
                        &&
                        <>
                            <HomeBoxDocuments
                                isMobile={true}
                            />

                            <HomeBoxLeases
                                homeConfig={homeConfig}
                                isMobile={true}
                            />
                        </>
                    }

                    {
                        isLocalHost
                        &&
                        <HomeDocumentsPanel
                            directories={directories}
                            isMobile={true}
                        />
                    }

                </div>


                {/* ------------------------------------------
                    Delivery
                ------------------------------------------ */}

                <div className="mobile-home-section">

                    <HeaderCard
                        id="3"
                        title="Delivery"
                        color={OMNISCAN_BLUE}
                        icon="traffic-light"
                    />

                    <HomeBoxMyTasks
                        isMobile={true}
                    />

                    <HomeBoxTasks
                        homeConfig={homeConfig}
                        isMobile={true}
                    />

                    <HomeBoxProjects
                        homeConfig={homeConfig}
                        isMobile={true}
                    />

                    <HomeBoxHelpDesk />

                </div>

            </div>


            {/* AI INSIGHTS */}

            {
                isLocalHost
                &&
                <AiInsightsPanel
                    isMobile={true}

                    critical={2}
                    medium={7}
                    low={15}

                    onOpen={
                        () =>
                            history.push(
                                "/insightdashboard"
                            )
                    }
                />
            }

        </div>
    );
}
